import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppContainerOptions, AppContainerService, BackdropContainerEnum, IAppContainerFrame, ISwUpdateOptions, SwUpdateService, UserMenuItemsEnum } from '@mydocma/app-container';
import package_json from '../../../package.json';
import { ScreenOrientationEnum, ScreenOrientationService } from '@mydocma/core';
import { RpImageViewerService } from 'projects/mydocma-rp/src/lib/rp-daily-report/daily-report/daily-file/rp-image-viewer.service';
import { UntilDestroy } from "@ngneat/until-destroy";
import { ConfigProvider } from '@mydocma/common';
import { IReportConfig } from 'projects/mydocma-rp/src/lib/rp-common/project/project.interface';
import { firstValueFrom } from 'rxjs';
import { BackdropService } from '@mydocma/component-library/src/lib/backdrop';
import { DeviceService } from '@mydocma/core/src/lib/device';

@UntilDestroy()
@Component({
    selector: 'mydocma-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    providers: [
        AppContainerService,
        AppContainerOptions,
    ],
})
export class MainComponent implements OnInit, IAppContainerFrame, OnDestroy {
    public version: string = package_json.version;
    appContainerOptions: AppContainerOptions;

    constructor(
        public options: AppContainerOptions,
        private appContainerService: AppContainerService,
        private configService: ConfigProvider<IReportConfig>,
        public readonly imageViewerService: RpImageViewerService,
        private readonly updateService: SwUpdateService,
        private backDropService: BackdropService,
        private readonly deviceService: DeviceService,
        private readonly screenOrientationservice: ScreenOrientationService
    ) {
        this.appContainerService.notifyChanges((appContainer) => {
            appContainer.appIcon.name = configService.getConfigData().appName;
            appContainer.appIcon.color = configService.getConfigData().appIconColor;
            appContainer.header.customerSelection = true;
            appContainer.header.projectSelection = true;
            appContainer.header.userMenuItems.shouldShowLogs = false;
            appContainer.header.userMenuItems.shouldShowConnectivity = false;
            appContainer.header.userMenuItems.version = package_json.version;
            appContainer.header.userMenuItems.items.forEach(value => {
                if (value.id === UserMenuItemsEnum.userSettings) {
                    value.hidden = true;
                }
            })
            this.appContainerOptions = appContainer;
        });

        this.updateService.attachBeforeSwUpdateCallback(this.beforeUpdate.bind(this));
    }

    private async beforeUpdate(): Promise<ISwUpdateOptions> {
        let canUpdate = true;

        const backDrops = await firstValueFrom(this.backDropService.activeBackdrops$);
        if (backDrops) {
            canUpdate = backDrops.find(bd => bd.options?.name === BackdropContainerEnum.MydocmaAppHeader) ? false : true;
        }

        return {
            allowUpdate: true,
            showUpdateDialog: true
        }

    }

    ngOnDestroy(): void { }

    ngOnInit(): void {

        if (this.deviceService.isMobil()) {
            this.screenOrientationservice.lock(ScreenOrientationEnum.portrait);
        }
    }

    acOnRegister(appContainer: AppContainerOptions) {
    }

    acOnUnregister(appContainer: AppContainerOptions) {
        appContainer.sideNavBar.buttons = [];
        appContainer.topActionsBar.buttons = [];
    }
}
